import React from "react";
import "./Buttons.scss";
import classnames from "classnames";
import "../../design-system/components/HrButtons.scss";

export const Button = ({ children, className, ...props }) => {
  return (
    <button type="button" className={classnames("hr-btn", "hr-btn--secondary", className)} {...props}>
      {children}
    </button>
  );
};

export const OrangeButton = ({
  className = "",
  children,
  disabled,
  onClick,
  ...props
}) => {
  return (
    <button
      type="button"
      className={classnames("hr-btn", "hr-btn--primary", "tw-text-center", "tw-mx-auto", className)}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export const OrangeButtonNoWidth = ({
  className = "",
  children,
  disabled,
  onClick,
  ...props
}) => {
  return (
    <button
      type="button"
      className={classnames("hr-btn", "hr-btn--primary", "tw-text-center", "tw-mx-auto", className)}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export const BlueButton = ({ children, disabled, onClick, className, ...props }) => {
  return (
    <button
      type="button"
      className={classnames("hr-btn", "hr-btn--secondary", className)}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export const TransparentButton = ({
  children,
  disabled,
  onClick,
  className,
  ...props
}) => {
  return (
    <button
      type="button"
      className={classnames("hr-btn", "hr-btn--ghost-outline", className)}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};
